function DefaultNavbar() {}

// Setting default values for the props of DefaultNavbar

// Typechecking props for the DefaultNavbar

export default DefaultNavbar;
